import { FC } from "react";
import { useWatch } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { SaveAlt } from "@mui/icons-material";

import { RowBlockType } from "@framework/types";

import { StyledButton } from "../../../../../../components/common/buttons/export-button/styled";

export interface IAnalyticsExportProps {
  onDiagramExport: () => Promise<void>;
  onTableExport: () => Promise<void>;
  disabled?: boolean;
}

export const AnalyticsExport: FC<IAnalyticsExportProps> = props => {
  const { disabled, onDiagramExport, onTableExport } = props;

  const chartView = useWatch({ name: "chartView" });
  const viewStyle = useWatch({ name: "viewStyle" });
  const view = chartView || viewStyle;

  const isChartView = view === RowBlockType.bar3D || view === RowBlockType.flipBar3D;

  return (
    <StyledButton
      startIcon={<SaveAlt />}
      onClick={() => void (isChartView ? onDiagramExport() : onTableExport())}
      disabled={disabled}
    >
      <FormattedMessage id="form.buttons.export" />
    </StyledButton>
  );
};
